const ALL_API = { // 积分
  // 根据条件获取会员所有积分信息列表
  getMemberScoreSearch: {
    method: 'get',
    url: '/api/member/memberScoreSearch'
  },
  // 获取会员积分流水列表
  getListMemberScore: {
    method: 'get',
    url: '/api/wechat/listMemberScore'
  },
  // 获取会员积分详情
  getInfoMemberScore: {
    method: 'get',
    url: '/api/wechat/infoMemberScore'
  }
}
export default ALL_API



// WEBPACK FOOTER //
// ./src/api/integral/index.js